module.exports = __webpack_public_path__ + "media/images/icons/two_arrows_sea_green-0e961b25bbbcd1c3848b5b9cf76f7907.svg";